'use client';

import { useState } from 'react';

import { SheetControlledTrigger } from '@sola/ark-core/molecules/sheet/sheet.tsx';
import { useMakeAPaymentCommitments } from '@sola/supporter-sdk/hooks/commitments.ts';

import { LocalAlertsProvider } from '../../molecules/local-alerts/local-alerts-provider.tsx';
import {
  MakeAPaymentAlert,
  MakeAPaymentAlertGlobal,
  MakeAPaymentAlertType,
} from '../../molecules/make-a-payment-alert/make-a-payment-alert.tsx';
import { MakeAPaymentSheet } from './make-a-payment-sheet.tsx';

export interface MakeAPaymentNoticeProps {
  onlyShowMissingPayment?: boolean;
  globalAlert?: boolean;
}

export const MakeAPaymentNotice: React.FC<MakeAPaymentNoticeProps> = ({
  onlyShowMissingPayment = false,
  globalAlert = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const {
    amountDue,
    hasMissedPayment,
    hasDueThisMonth,
    canPayAhead,
    alertCommitments,
  } = useMakeAPaymentCommitments();

  if (
    (!hasMissedPayment && onlyShowMissingPayment) ||
    (!hasMissedPayment && !hasDueThisMonth && !canPayAhead)
  ) {
    return;
  }

  const makeAPaymentAlert = {
    amountDue,
    commitments: alertCommitments,
    alertType: MakeAPaymentAlertType.payAhead,
    ...(hasMissedPayment && {
      alertType: MakeAPaymentAlertType.missingPayment,
    }),
    ...(hasDueThisMonth &&
      !hasMissedPayment && {
        alertType: MakeAPaymentAlertType.paymentDue,
      }),
  };

  if (globalAlert) {
    return <MakeAPaymentAlertGlobal {...makeAPaymentAlert} />;
  }

  return (
    <LocalAlertsProvider>
      <MakeAPaymentAlert
        {...makeAPaymentAlert}
        onButtonClick={() => setIsOpen(true)}
        controlledTrigger={SheetControlledTrigger}
      />
      <MakeAPaymentSheet open={isOpen} onOpenChange={setIsOpen} />
    </LocalAlertsProvider>
  );
};
